import { scribeHttpV2 } from '@/utils/scribeHTTP';
import { useQuery } from '@tanstack/react-query';

export interface CQCPracticeSearchResult {
  id: string;
  name: string;
  also_known_as: string | null;
  address: string | null;
  postcode: string | null;
  phone_number: string | null;
  region: string | null;
}

export interface CQCPracticeSearchResponse {
  results: CQCPracticeSearchResult[];
  total: number;
}

export const CQC_PRACTICE_SEARCH_KEY = 'cqc-practice-search';

const MIN_QUERY_LENGTH = 2;

export function useQueryCQCPractices(query: string, enabled: boolean = true) {
  const trimmedQuery = query.trim();
  const shouldFetch = enabled && trimmedQuery.length >= MIN_QUERY_LENGTH;

  return useQuery<CQCPracticeSearchResponse>({
    queryKey: [CQC_PRACTICE_SEARCH_KEY, trimmedQuery],
    queryFn: async () => {
      const { data } = await scribeHttpV2.get<CQCPracticeSearchResponse>(
        '/cqc-practices/search',
        {
          params: {
            q: trimmedQuery,
            limit: 30,
          },
        }
      );
      return data;
    },
    enabled: shouldFetch,
    staleTime: 1000 * 60 * 5,
  });
}
